import { useRequiresDesktop } from "../hooks/useRequiresDesktop";
import MobileNotSupported from "./MobileNotSupported";

/** Affiche uniquement l’écran mobile OU la page joueur — jamais les deux. */
const PlayerRoute = ({ children }) => {
  const blocked = useRequiresDesktop();
  if (blocked) return <MobileNotSupported />;
  return children;
};

export default PlayerRoute;
